import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { ChakraProvider } from "@chakra-ui/react";
import { KindeProvider } from "@kinde-oss/kinde-auth-react";
import { useNavigate } from "react-router-dom";
import ChatPage from "./ChatPage";
import LibraryPage from "./LibraryPage";

import HomePage from "./HomePage";
import SearchPage from "./SearchPage";
import CharacterDetailPage from "./CharacterDetailPage";
import TermsOfUsePage from "./TermsOfUsePage";
import PrivacyPolicyPage from "./PrivacyPolicyPage";
import theme from "./theme";
import AppShell from "./AppShell";
import { SessionBoundary } from "./session";
import useDocumentMeta, { RouteMeta, SITE_NAME } from "./seo";
import "./app.css";

function NotFoundPage() {
  useDocumentMeta({
    title: `Page not found - ${SITE_NAME}`,
    canonicalPath: "/",
    noindex: true,
  });
  return (
    <div className="empty-state">
      <h1>Page not found</h1>
      <a href="/">Back to discovery</a>
    </div>
  );
}

export function AppRoutes() {
  return (
    <AppShell>
      <RouteMeta />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/character/:publicId" element={<CharacterDetailPage />} />
        <Route path="/chat/:publicId" element={<ChatPage />} />
        <Route path="/chats" element={<LibraryPage key="chats" />} />
        <Route path="/saved" element={<LibraryPage key="saved" saved />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route
          path="*"
          element={
            <NotFoundPage />
          }
        />
      </Routes>
    </AppShell>
  );
}

function Authentication({ children }) {
  const navigate = useNavigate();
  return (
    <KindeProvider
      clientId={
        process.env.REACT_APP_KINDE_CLIENT_ID ||
        "936ab40f9ca744c4b9a2ef40118731ef"
      }
      domain={
        process.env.REACT_APP_KINDE_DOMAIN || "https://charchat.kinde.com"
      }
      audience={process.env.REACT_APP_KINDE_AUDIENCE || undefined}
      redirectUri={
        process.env.REACT_APP_KINDE_REDIRECT_URI || window.location.origin
      }
      logoutUri={window.location.origin}
      useInsecureForRefreshToken={
        process.env.REACT_APP_KINDE_INSECURE_REFRESH === "true"
      }
      forceChildrenRender
      callbacks={{
        onSuccess: (_user, state) => {
          const target = state?.returnTo;
          navigate(
            typeof target === "string" && /^\/(?!\/)/.test(target)
              ? target
              : "/",
            { replace: true },
          );
        },
      }}
    >
      {children}
    </KindeProvider>
  );
}
function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Authentication>
          <SessionBoundary>
            <AppRoutes />
          </SessionBoundary>
        </Authentication>
      </Router>
    </ChakraProvider>
  );
}

export default App;
